import { defineNuxtPlugin } from '#app/nuxt'
import { LazyLabsComponent, LazyLabsLink, LazyLabsLoader, LazyLabsLogo } from '#components'
const lazyGlobalComponents = [
  ["LabsComponent", LazyLabsComponent],
["LabsLink", LazyLabsLink],
["LabsLoader", LazyLabsLoader],
["LabsLogo", LazyLabsLogo],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
